export const FETCH_QUERY_DEBTORS_REQUEST = "DEBTORS/FETCH_QUERY_REQUEST";
export const FETCH_QUERY_DEBTORS_SUCCESS = "DEBTORS/FETCH_QUERY_SUCCESS";
export const FETCH_QUERY_DEBTORS_FAILURE = "DEBTORS/FETCH_QUERY_FAILURE";
export const CREATE_DEBTOR_REQUEST = "DEBTORS/CREATE_NEW_REQUEST";
export const CREATE_DEBTOR_SUCCESS = "DEBTORS/CREATE_NEW_SUCCESS";
export const CREATE_DEBTOR_FAILURE = "DEBTORS/CREATE_NEW_FAILURE";
export const CLOSE_CREATE_DEBTOR = "DEBTORS/UI/CLOSE_DIALOG";
export const OPEN_CREATE_DEBTOR = "DEBTORS/UI/OPEN_DIALOG";
